import * as React from "react";
import { QRCodeCanvas } from "qrcode.react";
import {
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Link,
  Typography,
} from "@mui/material";
import { qrPdfPoweredByText } from "../../../utils/config";
import goodAssistant from "../../homePage/images/good-assistant.png";
import badAssistant from "../../homePage/images/bad-assistant.png";

interface QrCodePopupProps {
  open: boolean;
  onClose: () => void;
  qrValue: string;
  imageUrl?: string;
  companyName?: string;
  shortUrl?: string;
}

export const QrCodePopup: React.FC<QrCodePopupProps> = ({
  open,
  onClose,
  qrValue,
  imageUrl,
  companyName,
  shortUrl,
}) => {
  const printPopupContent = (printSize: "large" | "small") => {
    const isSmall = printSize === "small";
    const qrCodeCanvas = document.querySelector("canvas")?.toDataURL();

    const popupWindow = window.open("", "_blank");
    if (popupWindow) {
      popupWindow.document.open();
      popupWindow.document.write(`
        <html>
          <head>
            <title>Print QR Code</title>
            <style>
              body {
                margin: 0;
                padding: 24px;
                font-family: "Segoe UI", Arial, sans-serif;
                background: #f4f7fb;
                color: #1f2a37;
              }

              .poster {
                max-width: ${isSmall ? "460px" : "720px"};
                margin: 0 auto;
                text-align: center;
                background: #ffffff;
                border: 4px solid #000000;
                border-radius: 18px;
                padding: ${isSmall ? "22px" : "28px"};
              }

              .eyebrow {
                display: inline-block;
                margin: 0 0 12px;
                padding: 6px 12px;
                border-radius: 999px;
                background: #e8f0fe;
                color: #1a73e8;
                font-size: 14px;
                font-weight: 700;
                letter-spacing: 0.4px;
              }

              h1 {
                margin: 0;
                font-size: ${isSmall ? "30px" : "40px"};
                line-height: 1.1;
                color: #0f172a;
              }

              .subtitle {
                margin: 20px 0 10px;
                font-size: ${isSmall ? "18px" : "22px"};
                font-weight: 600;
                color: #334155;
              }

              .image-container {
                margin: 4px 0 18px;
              }

              .profile-image {
                width: 140px;
                height: 140px;
                border-radius: 50%;
                object-fit: cover;
                border: 4px solid #dbeafe;
              }

              .scan-box {
                margin: 0px auto;
                width: ${isSmall ? "220px" : "270px"};
                background: #ffffff;
                border: 4px solid #1a73e8;
                border-radius: 16px;
                padding: ${isSmall ? "12px" : "16px"};
              }

              .scan-label {
                margin: 16px 0 8px;
                font-size: 18px;
                font-weight: 700;
                color: #0f172a;
              }

              .assistant-row {
                margin: 22px auto 0;
                display: flex;
                justify-content: center;
                gap: 24px;
                flex-wrap: wrap;
              }

              .assistant-item {
                width: 230px;
                text-align: center;
                border: 2px solid #dbe3ef;
                border-radius: 16px;
                padding: 16px 12px;
                background: #f8fbff;
              }

              .assistant-item img {
                width: 160px;
                height: 160px;
                object-fit: contain;
                display: block;
                margin: 0 auto 12px;
              }

              .assistant-item p {
                margin: 0;
                font-size: 14px;
                font-weight: 800;
                color: #1e293b;
              }

              .assistant-positive {
                border-color: #b7f0c1;
                background: #f1fff4;
              }

              .assistant-negative {
                border-color: #ffd3d6;
                background: #fff5f6;
              }

              .note {
                margin: 0;
                font-size: 14px;
                color: #64748b;
              }

              .powered-by {
                margin-top: 22px;
                font-size: 15px;
                color: #1565c0;
                font-weight: 700;
              }

              @media print {
                body {
                  background: #ffffff;
                  padding: 0;
                }

                .poster {
                  border-radius: 10px;
                  border: 8px solid #535151;
                  max-width: 100%;
                }
              }
            </style>
          </head>
          <body>
            <div class="poster"> 
              ${companyName ? `<h2 style="margin: 0 0 8px; font-size: ${isSmall ? "20px" : "26px"}; color: #0b5cff; font-weight: 800;">${companyName}</h2>` : ""}
              <h1>RATE OUR STAFF</h1>
            


              ${imageUrl ? `<div class="image-container"><img src="${imageUrl}" alt="Profile" class="profile-image"/></div>` : ""}
              ${isSmall
          ? ""
          : `<div class="assistant-row">
                <div class="assistant-item assistant-positive">
                  <img src="${goodAssistant}" alt="Great Service" />
                  <p>Excellent Service</p>
                </div>
                <div class="assistant-item assistant-negative">
                  <img src="${badAssistant}" alt="Needs Improvement" />
                  <p>Needs Improvement</p>
                </div>
              </div>`
        }
  
              <p class="subtitle">Scan the QR code and share your experience</p>

              <div class="scan-box">
                  ${qrCodeCanvas ? `<img src="${qrCodeCanvas}" alt="QR Code" width="${isSmall ? "190" : "230"}" height="${isSmall ? "190" : "230"}" />` : ""}
              </div>

              ${shortUrl ? `<p style="margin: 12px 0 2px; font-size: 14px; color: #64748b;">Scan the QR code or visit,</p><p style="margin: 0 0 4px; font-size: ${isSmall ? "18px" : "22px"}; font-weight: 700; color: #1a73e8;">${shortUrl.replace(/^https?:\/\//, '').replace(/rankme/i, 'RankMe')}</p>` : ""}
              <p class="note">Your feedback helps us serve you better.</p>
              <p class="powered-by">${qrPdfPoweredByText}</p>
            </div>
            <script>
              window.onload = function() {
                window.print();
                window.close();
              }
            </script>
          </body>
        </html>
      `);
      popupWindow.document.close();
    }
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ textAlign: "center" }}>
        QR Code for {companyName || "Review Our Staff"}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ textAlign: "center", mt: 2 }}>
          {imageUrl && (
            <Box sx={{ mb: 2 }}>
              <Box
                component="img"
                src={imageUrl}
                alt="Profile"
                sx={{
                  width: 120,
                  height: 120,
                  borderRadius: "50%",
                  objectFit: "cover",
                  mx: "auto",
                  display: "block",
                }}
              />
            </Box>
          )}
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <QRCodeCanvas value={qrValue} size={135} />
          </Box>
          {shortUrl && (
            <Box sx={{ mt: 1.5, textAlign: "center" }}>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Scan the QR code or visit
              </Typography>
              <Link href={shortUrl} target="_blank" rel="noopener noreferrer" variant="h6" fontWeight={700}>
                {shortUrl.replace(/^https?:\/\//, '').replace(/rankme/i, 'RankMe')}
              </Link>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
        <Button
          onClick={() => printPopupContent("large")}
          variant="contained"
          color="primary"
        >
          Print Large
        </Button>
        <Button
          onClick={() => printPopupContent("small")}
          variant="outlined"
          color="primary"
        >
          Print Small
        </Button>
        <Button onClick={onClose} variant="outlined" color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
